import { Dialog, DialogContent } from '@mui/material';

import ModalContent from 'src/components/ModalContent/ModalContent';

interface AddNoteModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (values: { description: string; subject: string }) => void;
}

export default function AddNoteModal({ open, onClose, onSubmit }: AddNoteModalProps): JSX.Element {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="create-note-offer-dialog"
            sx={{
                '& .MuiDialog-paper': {
                    width: '400px',
                },
            }}
        >
            <DialogContent>
                <ModalContent
                    handleClose={onClose}
                    buttonText="Create Note"
                    header="Create Note"
                    initialValues={{
                        description: '',
                        subject: '',
                    }}
                    handleFormSubmit={onSubmit}
                    isSubmitModal
                    handleAction={() => {}}
                    message=""
                />
            </DialogContent>
        </Dialog>
    );
}
